import React from 'react'
import PlaylistSeriesIcon from '../../../assets/codicons/video-icons/playlist-series'
import PropTypes from 'prop-types'

const VideoListIcon = props => {
  return (
    <React.Fragment>
      <div className='type'>{props.type}</div>
      <div className='hover-icon'>
        <PlaylistSeriesIcon />
      </div>
    </React.Fragment>
  )
}

VideoListIcon.propTypes = {
  type: PropTypes.string
}

export default VideoListIcon
